export default __webpack_public_path__ + "static/media/the_ci_group_logo_signature.9f9b7a81.png";